import { z } from 'zod';
import { SortOrder } from './sortOrder.js';
/**
 * One column's sort, shaped like Material-UI's `GridSortItem` so a data grid's `sortModel` can be
 * handed to an API unchanged.
 */
export const SortItemSchema = z.object({
    field: z.string(),
    sort: z.enum(SortOrder),
});
/**
 * The columns to sort by, in precedence order — Material-UI's `GridSortModel`. This is the standard
 * sort parameter for new APIs as of 2025; every other sort shape in the monorepo is legacy. See the
 * package README.
 */
export const SortModelSchema = z.array(SortItemSchema);
/** A `SortModelSchema` restricted to the columns an endpoint can sort by. */
export function SortModelSchemaFor(fieldSchema) {
    return z.array(z.object({
        field: fieldSchema,
        sort: z.enum(SortOrder),
    }));
}
//# sourceMappingURL=sortModel.js.map